// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h6sSx","textarea":"styles_textarea__1lj8E"};